var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"step-indicator"},[(_vm.isCompleted)?_c('InitialAvatarIcon',{staticClass:"step-indicator__completed",attrs:{"icon":"EF0070","size":"medium"}}):_c('BadgeCounterFoundation',{staticClass:"step-indicator__badge",attrs:{"value":_vm.icon || 0,"disabled":_vm.isDisabled}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }